<template>
  <transition name="router-anim">
    <div class="kits">
      <!-- FBA Inventory Table -->
      <div class="form">
        <DescriptionModal class="description-modal" :description="'This page displays the inventory listing available in amazon.'" />
        <div class="inv-data" >
          <h1>Amazon Inventory</h1>
          <div class="inv-data-table">
            <table v-if="!isEmpty" class="fba-table styled-table">
              <thead>
                <tr>
                  <th class="postion-sticky title-data">Type</th>
                  <th class="title-data">Product Name</th>
                  <th class="title-data">ASIN</th>
                  <th class="title-data">Seller SKU</th>
                  <th class="title-data">Condition</th>
                  <th class="title-data">Fulfillable Quantity</th>
                  <th class="title-data">Inbound Working Quantity</th>
                  <th class="title-data">Inbound Shipped Quantity</th>
                  <th class="title-data">Inbound Receiving Quantity</th>
                  <th class="title-data">Total Reserved Quantity</th>
                  <th class="title-data">Pending Customer Order Quantity</th>
                  <th class="title-data">Pending Transshipment Quantity</th>
                  <th class="title-data">FC Processing Quantity</th>
                  <th class="title-data">Total Researching Quantity</th>
                  <th class="title-data">Customer Damaged Quantity</th>
                  <th class="title-data">Warehouse Damaged Quantity</th>
                  <th class="title-data">Distributor Damaged Quantity</th>
                  <th class="title-data">Carrier Damaged Quantity</th>
                  <th class="title-data">Defective Quantity</th>
                  <th class="title-data">Expired Quantity</th>
                  <th class="title-data">Total Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr  v-for="item in sortedTableData" :key="item.id">
                <td class="postion-sticky">{{ getKitType(item.asin) }}</td>
                <td style="min-width:500px">{{ item.productName }}</td>
                <td>{{ item.asin }}</td>
                <td style="min-width:100px">{{ item.sellerSku }}</td>
                <td>{{ item.condition }}</td>
                <td>{{ item.fulfillableQuantity }}</td>
                <td>{{ item.inboundWorkingQuantity }}</td>
                <td>{{ item.inboundShippedQuantity }}</td>
                <td>{{ item.inboundReceivingQuantity }}</td>
                <td>{{ item.totalReservedQuantity }}</td>
                <td>{{ item.pendingCustomerOrderQuantity }}</td>
                <td>{{ item.pendingTransshipmentQuantity }}</td>
                <td>{{ item.fcProcessingQuantity }}</td>
                <td>{{ item.totalResearchingQuantity }}</td>
                <td>{{ item.customerDamagedQuantity }}</td>
                <td>{{ item.warehouseDamagedQuantity }}</td>
                <td>{{ item.distributorDamagedQuantity }}</td>
                <td>{{ item.carrierDamagedQuantity }}</td>
                <td>{{ item.defectiveQuantity }}</td>
                <td>{{ item.expiredQuantity }}</td>
                <td>{{ item.totalQuantity }}</td>
                </tr>
              </tbody>
            </table>
            <p v-else class="no-data-message">No data available</p>
          </div>
          <!-- Message for empty data -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'FbaInventoryTable',
  data() {
    return {
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(['getAmazonFba']),
    isEmpty() {
      return !Array.isArray(this.getAmazonFba) || this.getAmazonFba.length === 0;
    },
    sortedTableData() {
      if (Array.isArray(this.tableData) && this.tableData.length > 0) {
        return this.tableData.sort((a, b) => {
          const typeA = this.getKitType(a.asin).toUpperCase(); // Use toUpperCase() to handle case-insensitive sorting
          const typeB = this.getKitType(b.asin).toUpperCase();

          if (typeA > typeB) {
            return this.sortAscending ? -1 : 1;
          }
          if (typeA < typeB) {
            return this.sortAscending ? 1 : -1;
          }
          return 0;
        });
      } else {
        return this.tableData;
      }
    },
  },
  methods: {
    ...mapActions(['setSalesData','setWooSalesData','setSalesSubData','setWooSalesSubData']),
    sortData(key) {
      // Toggle sorting order when the same column is clicked
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc'; // Default to ascending order when a new column is sorted
      }
    },
    formattedDate(date) {
      // Format the date as 'MM/DD/YYYY' 
      return moment(date).format('MM/DD/YYYY');
    },
    getKitType(asin) {
      const kitTypes = {
        'B086D5RQ7N': 'F1',
        'B086D4464B': 'F2',
        'B086DCV9Q7': 'F3',
        'B0C7CXXSRH': 'R1',
        'B0C7D1RCQ4': 'R2',
        'B0C7D167SM': 'R3'
      };
      return kitTypes[asin] || 'Unknown'; // Default value if ASIN not found
    },
  },
  watch:{
    getAmazonFba(obj) {
      this.tableData = obj;
    }
  },
  mounted() {
    this.tableData = this.$store.getters.getAmazonFba;
  }
};
</script>

<style scoped>
.kits {
  margin: 15px 0;
}
.description-modal{
  text-align: start;
  position: absolute;
  top: 0px;
  left: 1px;
}
.form {
  padding-top: 20px;
}
.form, .sales-data {
  background-color: #fff;
  width: 100%;
  overflow-x: auto;
}
.form, .inv-data {
  background-color: #fff;
  width: 100%;

}
.inv-data-table {
  overflow-x: auto;
}

.editlog {
  padding-top: 20px;
}

.fba-table {
  width: 100%;
  border-collapse: unset;
}
.sales-table {
  width: 100%;
  border-collapse: collapse;
}

.fba-table th, .sales-table th, .fba-table td, .sales-table td {
  padding: 0 0 0 8px;
  text-align: left;
}

.fba-table th, .sales-table th {
  background-color: #005eb8;
  color: #f5f7fa;
  font-family: TTNormsMedium, sans-serif;
}

.filters {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.filters label {
  margin-right: 10px;
  font-family: TTNormsMedium, sans-serif;
  color: #b3b3b3;;;
}

.filters input {
  margin-right: 10px;
}

.filter-wrap-custom {
  display: flex;
  justify-content: flex-end;
  margin-left: 10px;
  width: 200px;
}
.filter-wrap-btn {
  display: inline-flex;
  justify-content: flex-end;
  margin-left: 10px;
}
.filter-list-wrap {
  position: absolute;
  right: 0px;
  top: 35px;
  width: 160px;
  background-color: #fff;
  box-shadow: 0px 0px 5px 1px rgba(152, 164, 174, 0.4);
  z-index: 1;
}

.no-data-message {
  color: red;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}
 h1 {
  padding-bottom: 20px ;
  font-family: TTNormsBold, sans-serif;
  color: #1546ad;
  text-align: center;
  font-size: 20px;

 }

 h2 {
  padding-top: 7px ;
  font-family: TTNormsBold, sans-serif;
  color: #1546ad;
  text-align: center;
  font-size: 15px;
  padding-right: 25px;
 }

 .input-filter {
  padding: 5px 10px;
  width: 100%;
  font-size: 16px;
  text-align: left;
  outline: none;
  border-radius: 5px;
  font-family: TTNormsRegular, sans-serif;
  background-color:#005eb8;
  color: #fff;
  border: 1px solid #005eb8;
  text-align-last: left;
}

.input-sub-filter {
  padding: 5px 10px;
  width: 100%;
  font-size: 16px;
  text-align: left;
  outline: none;
  border-radius: 5px;
  font-family: TTNormsMedium, sans-serif;
  background-color:#fff;
  color: #005eb8;
  border: 1px solid #cccccc;
  text-align-last: left;
}

.input-sub-filter option {
  font-family: TTNormsLight, sans-serif;
  background-color: #fff;
  color: #373737;
  border: 1px solid #fff;
}

.input-filter option {
  font-family: TTNormsLight, sans-serif;
  background-color: #fff;
  color: #373737;
  border: 1px solid #fff;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 100px;
  width: 100%;
}

.btn {
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 5px 15px 5px 15px;
  cursor: pointer;
  border-radius: 5px;
}

.search-input {
  font-size: 14px;
  font-weight: 500px;
  font-family: TTNormsMedium, sans-serif;
  background-color: #fff;
  outline: none;
  border-radius: 10px;
  transition: all 0.5s linear;
  margin-right: 10px;
  margin-left: 10px;
  border: 1px solid #cccccc;
  height: 20px;
  padding-top: 14px;
  padding-bottom: 14px;
}
.search-input::placeholder {
  color: #cccccc;
  font-family: TTNormsMedium, sans-serif;
  opacity: 0.8;
}
.search-input:focus {
  background-color: #e3e3e3;
}
.text-right{
text-align: right !important;
padding-right: 5px !important;
}
.text-center{
  text-align: center !important;
}
.postion-sticky {
  position: sticky;
  left: 0;
  
  z-index: 1; /* Ensure sticky column stays on top */
  width: 150px; /* Fixed width for the sticky column */
}

.fba-table th:first-child{
  background-color: #005eb8;
  color: #fff;
  position: sticky;   /* Sticky column */
  left: 0;
  z-index: 1; 

}
.fba-table td:first-child {
  background-color: #fff;  /* Light background for the first column */
  position: sticky;   /* Sticky column */
  left: 0;
  z-index: 1;  /* Ensure the first column stays on top */
}
.fba-table tr:nth-child(even) td:first-child {
  background-color:  #f3f3f3;  /* Example color for alternate rows */
}

/* Style for the rest of the columns (both header and body cells) */

.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
.description-modal{
  text-align: end;
  position: absolute;
  z-index: 1;
  width: 100%;
}
</style>
